(function () {
  /* ── Helpers ──────────────────────────────────────────────── */

  function closeAllPickers() {
    document.querySelectorAll('.quick-add-wrap').forEach(function (w) {
      w.classList.remove('picker-open');
      var p = w.querySelector('.quick-add-picker');
      if (p) p.hidden = true;
    });
  }

  /* ── Mouse-leave: hide pickers only when cursor EXITS the card ── */
  /* Use mouseout + relatedTarget so we only fire when leaving the whole card */

  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest('product-card, .product-card');
    if (!card) return;
    /* relatedTarget = where cursor went TO. If still inside card, ignore. */
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    closeAllPickers();
  });

  /* ── Click outside: close pickers ─────────────────────── */

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.quick-add-wrap')) closeAllPickers();
  });

  /* ── Quick Add button click ───────────────────────────── */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add-btn');
    if (!btn || btn.disabled) return;

    var toggleId = btn.dataset.quickAddToggle;
    if (toggleId) {
      /* Multi-variant: toggle the inline size picker */
      e.preventDefault();
      e.stopPropagation();
      var wrap = btn.closest('.quick-add-wrap');
      var picker = document.getElementById('quick-add-' + toggleId);
      if (!wrap || !picker) return;

      var wasOpen = wrap.classList.contains('picker-open');
      closeAllPickers();

      if (!wasOpen) {
        picker.hidden = false;
        wrap.classList.add('picker-open');
      }
    } else {
      /* Single variant: AJAX add directly */
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.productId;
      if (variantId) addToCart(variantId, btn);
    }
  });

  /* ── Size chip click inside picker ─────────────────────── */

  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.quick-add-size');
    if (!sizeBtn || sizeBtn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = sizeBtn.dataset.variantId;
    var wrap = sizeBtn.closest('.quick-add-wrap');
    var mainBtn = wrap && wrap.querySelector('.quick-add-btn');

    closeAllPickers();
    if (variantId) addToCart(variantId, mainBtn || sizeBtn);
  });

  /* ── AJAX add-to-cart ──────────────────────────────────── */

  function addToCart(variantId, btn) {
    if (!variantId || !btn) return;

    var textEl = btn.querySelector('.quick-add-btn-text');
    var originalText = textEl ? textEl.textContent.trim() : 'Quick Add';

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        btn.disabled = false;

        if (data.status === 422 || data.description) {
          if (textEl) textEl.textContent = 'Sold Out';
          setTimeout(function () { if (textEl) textEl.textContent = originalText; }, 2000);
          return;
        }

        if (textEl) textEl.textContent = 'Added!';
        setTimeout(function () { if (textEl) textEl.textContent = originalText; }, 1800);

        refreshCart();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  /* ── Refresh cart UI ───────────────────────────────────── */

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(
          '.cart-count, [data-cart-count], .cart-item-count, .site-header__cart-count'
        ).forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });

        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:add', { detail: cart }));

        fetch('/?sections=cart-drawer')
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            if (sections['cart-drawer']) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
              var fresh = doc.querySelector('[id*="CartDrawer"], [id*="cart-drawer"], #CartDrawer');
              var existing = document.querySelector('[id*="CartDrawer"], [id*="cart-drawer"], #CartDrawer');
              if (fresh && existing) existing.outerHTML = fresh.outerHTML;
            }
          })
          .catch(function () {});
      })
      .catch(function () {});
  }
}());
